var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{staticClass:"text-green-500 mr-4",attrs:{"icon":"check"}})
}
var staticRenderFns = []

export { render, staticRenderFns }